import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const MailForward = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <SvgIcon {...props} ref={ref}  viewBox="0 0 16 17">
      <mask id="mask0_1005_979" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <rect y="0.5" width="16" height="16" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_1005_979)">
        <path d="M8.00016 9.1665L2.66683 5.83317V12.4998H8.66683V13.8332H2.66683C2.30016 13.8332 1.98639 13.7027 1.7255 13.4418C1.46416 13.1805 1.3335 12.8665 1.3335 12.4998V4.49984C1.3335 4.13317 1.46416 3.81939 1.7255 3.5585C1.98639 3.29717 2.30016 3.1665 2.66683 3.1665H13.3335C13.7002 3.1665 14.0142 3.29717 14.2755 3.5585C14.5364 3.81939 14.6668 4.13317 14.6668 4.49984V9.1665H13.3335V5.83317L8.00016 9.1665ZM8.00016 7.83317L13.3335 4.49984H2.66683L8.00016 7.83317ZM12.6668 15.8332L11.7335 14.8998L12.7835 13.8332H10.0002V12.4998H12.7835L11.7168 11.4332L12.6668 10.4998L15.3335 13.1665L12.6668 15.8332ZM2.66683 5.83317V13.1665V9.1665V9.2165V4.49984V5.83317Z" fill="#989898"/>
      </g>
    </SvgIcon>
  )
);

MailForward.displayName = 'MailForward';

export default MailForward;
